"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _default = exports.default = function _default(key, selector, initialState) {
  return function (store) {
    if (!store[key]) {
      return selector(initialState);
    }
    return selector(store[key]);
  };
};